export function clamp(number: number, min: number, max: number): number {
	return Math.max(min, Math.min(number, max));
}

export function getTwoDigitStringFromNumber(val: number): string {
	return val.toString().padStart(2, "0");
}

export function positiveModulo(number: number, modulo: number): number {
	return ((number % modulo) + modulo) % modulo;
}

export const calculateMediaDurationMinutes = (durationInSeconds: number): number =>
	Math.max(1, Math.round(durationInSeconds / 60));
